import { initSlider } from "../ui/slider/slider";

import "./jiffymade-landing-reviews.scss";

export const initReviews = () => {
  initSlider({
    containerSelector: ".js-jiffymade-landing-reviews-section-swiper",
    spaceBetween: 16,
    trackingPage: "custom_print_shirts",
    delayTouchDevices: 5000
  });
};

export default initReviews;
